import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IonicPage, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { MenuProvider } from './../../../../providers/menu/menu';
import { RoleProvider } from './../../../../providers/role/role';

@IonicPage()
@Component({
  selector: 'page-configuration-role-edit',
  templateUrl: 'configuration-role-edit.html',
})
export class ConfigurationRoleEditPage {
  public formData: FormGroup;
  menus: any = [];
  reqMenus: any;
  treeMenu: any = [];
  Family: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private menuPrvdr: MenuProvider,
    private translateSvc: TranslateService,
    private rolePrvdr: RoleProvider,
    private formBuilder: FormBuilder
  ) {
    this.formData = this.formBuilder.group({
      name: ['', Validators.compose([Validators.required])],
    });
  }

  ionViewDidEnter() {
    this.buildMenu();
  }

  ionViewDidLoad() {
    this.formData.setValue({
      name: this.navParams.data.name,
    });
  }

  buildMenu() {
    //ROOT: 5b3300fa379913557cf7b539
    let menu = [];
    let currentMenu = this.navParams.data.menus;

    this.reqMenus = this.menuPrvdr.listByRoot('5b3300fa379913557cf7b539').subscribe((res: any) => {
      if (res.success === true) {
        res.data.forEach((element) => {
          this.menuPrvdr.listByRoot(element._id).subscribe((child: any) => {
            if (child.success === true) {
              if (child.data.length > 0) {
                child.data.forEach((z) => {
                  currentMenu.forEach((x) => {
                    if (z._id === x) {
                      z.checked = true;
                    }
                  });
                });
                element.child = child.data;
              } else {
                element.child = [];
              }
            } else {
              element.child = [];
            }
          });
          currentMenu.forEach((x) => {
            if (element._id === x) {
              element.checked = true;
            }
          });
          menu.push(element);
        });
        this.treeMenu = menu;
      } else {
        this.showToast('ERROR:  Failed load menu!');
      }
    });
  }

  sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break;
      }
    }
  }

  onEditData() {
    let checkedMenus = [];
    this.treeMenu.forEach((menu) => {
      if (menu.checked === true) {
        checkedMenus.push(menu._id);
        if (menu.child.length > 0) {
          menu.child.forEach((menuChild) => {
            if (menuChild.checked === true) {
              checkedMenus.push(menuChild._id);
            }
          });
        }
      }
    });

    let data = {
      id: this.navParams.data._id,
      name: this.formData.value.name,
      menus: checkedMenus,
    };

    let loading = this.loadingCtrl.create({
      spinner: 'dots',
      content: this.translateSvc.instant('Editing Role...'),
      duration: 3000,
    });
    loading.present();

    this.rolePrvdr.edit(data).subscribe(
      (res: any) => {
        loading.dismiss();
        if (res.success === true) {
          this.showToast(this.translateSvc.instant('Role edited succesfully.'));
          this.navCtrl.pop();
        } else {
          this.showToast('ERROR: ' + res.message);
        }
      },
      (error) => {
        loading.dismiss();
        this.showToast('ERROR: ' + error.error.message);
      }
    );
  }

  onCancel() {
    this.navCtrl.pop();
  }

  private showToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }

  ionViewDidLeave() {
    this.reqMenus.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-role/configuration-role-edit/configuration-role-edit.ts